import React, { createContext, useState, useContext } from "react";
import { formatDate } from "../../../../utils/formatDate";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";

const PainelNfeContext = createContext();

const PainelNfeContextProvider = ({ children }) => {
  const { queryParams } = useContext(QueryParamsContext);

  /* Auxiliares */
  const [mainLoading, setMainLoading] = useState(false);
  const [loadingInputs, setLoadingInputs] = useState(false);
  const [modelsListLoading, setModelsListLoading] = useState(false);

  /* Painel de Busca */
  const [optionsStatus, setOptionsStatus] = useState(null);
  const [cfop, setCfop] = useState("");
  const [receiver, setReceiver] = useState("");
  const [numberNfe, setNumberNfe] = useState("");
  const [accesKey, setAccesKey] = useState("");
  const [dataRows, setDataRows] = useState([]);
  const [selectedItem, setSelectedItem] = useState([]);
  const [filterSeries, setFilterSeries] = useState(null);
  const [iniDate, setIniDate] = useState(
    formatDate({ date: new Date(), separator: "-", format: "yyyy-mm-dd" })
  );
  const [finallyDate, setFinallyDate] = useState(
    formatDate({ date: new Date(), separator: "-", format: "yyyy-mm-dd" })
  );
  const [typeNfe, setTypeNfe] = useState(true);
  const [defaultListModels] = useState([
    { label: "Modelo 55", value: "55" },
    { label: "Modelo 65", value: "65" },
  ]);
  const [listModels, setListModels] = useState([]);

  /* Parametros Find */
  const [queryWhere, setQueryWhere] = useState({
    idempresa: parseInt(queryParams.id),
    modelo: "55",
    tipo: "S",
    indicadoremitente: "P",
  });
  const [queryOrWhere, setQueryOrWhere] = useState({});
  const [queryBetween, setQueryBetween] = useState(
    `filter[between]=dataemissao,${iniDate},${finallyDate}`
  );

  /* Carta de Correção */
  const [historyCC, setHistoryCC] = useState([]);
  const [ccDescription, setCcDescription] = useState("");
  const [ccError, setCcError] = useState({});
  const [ccId, setCCId] = useState(null);

  /* Inutilização da Nota */
  const [initialNumber, setInitialNumber] = useState("");
  const [finalNumber, setFinalNumber] = useState("");
  const [justify, setJustify] = useState("");
  const [listSeries, setListSeries] = useState([]);
  const [series, setSeries] = useState(null);
  const [model, setModel] = useState({ label: "55", value: 55 });
  const [filterModel, setFilterModel] = useState(null);
  const [inutError, setInutError] = useState({});
  const [saleSituation, setSaleSituation] = useState({});
  const [hasSalesInNfe, setHasSalesInNfe] = useState(false);
  const [situationList, setSituationList] = useState([]);
  const [tabIndexUnunsed, setTabIndexUnunsed] = useState(0);

  /* Downloads */
  const [downloadXml, setDownloadXml] = useState(true);
  const [downloadDanfePdf, setDownloadDanfePdf] = useState(true);
  const [downloadCCe, setDownloadCCe] = useState(true);
  const [downloadXmlReturn, setDownloadXmlReturn] = useState(true);
  const [singleFolder, setSingleFolder] = useState(true);
  const [hasCanceled, setHasCanceled] = useState(false);

  return (
    <PainelNfeContext.Provider
      value={{
        optionsStatus,
        setOptionsStatus,
        cfop,
        setCfop,
        receiver,
        setReceiver,
        numberNfe,
        setNumberNfe,
        dataRows,
        setDataRows,
        selectedItem,
        setSelectedItem,
        iniDate,
        setIniDate,
        finallyDate,
        setFinallyDate,
        queryWhere,
        setQueryWhere,
        queryOrWhere,
        setQueryOrWhere,
        queryBetween,
        setQueryBetween,
        historyCC,
        setHistoryCC,
        ccDescription,
        setCcDescription,
        ccError,
        setCcError,
        ccId,
        setCCId,
        initialNumber,
        setInitialNumber,
        finalNumber,
        setFinalNumber,
        justify,
        setJustify,
        listSeries,
        setListSeries,
        series,
        setSeries,
        inutError,
        setInutError,
        saleSituation,
        setSaleSituation,
        hasSalesInNfe,
        setHasSalesInNfe,
        situationList,
        setSituationList,
        filterSeries,
        setFilterSeries,
        typeNfe,
        setTypeNfe,
        defaultListModels,
        listModels,
        setListModels,
        accesKey,
        setAccesKey,
        downloadXml,
        setDownloadXml,
        downloadDanfePdf,
        setDownloadDanfePdf,
        downloadCCe,
        setDownloadCCe,
        downloadXmlReturn,
        setDownloadXmlReturn,
        mainLoading,
        setMainLoading,
        loadingInputs,
        setLoadingInputs,
        modelsListLoading,
        setModelsListLoading,
        singleFolder,
        setSingleFolder,
        hasCanceled,
        setHasCanceled,
        model,
        setModel,
        tabIndexUnunsed,
        setTabIndexUnunsed,
        filterModel,
        setFilterModel,
      }}
    >
      {children}
    </PainelNfeContext.Provider>
  );
};

export { PainelNfeContextProvider, PainelNfeContext };
